import http from '@/http'
import { AnnouncementLibraryResponse } from '@/interfaces/library/announcement';

/**
 * Controller for handling library-specific announcement operations.
 */
export default class AnnouncementLibraryController {
  private static readonly BASE_URL = '/announcements';

  /**
   * Fetches active announcements for the library view.
   * These are typically pre-filtered and translated by the backend.
   * @returns Promise resolving to an array of active announcements.
   * @throws If the API request fails.
   */
  static async getActiveAnnouncements(): Promise<AnnouncementLibraryResponse[]> {
    try {
      const response = await http.get<AnnouncementLibraryResponse[]>(this.BASE_URL);
      return response.data;
    } catch (error) {
      console.error('Error fetching active announcements:', error);
      throw error;
    }
  }
}
